/* eslint-disable */ 
import React from 'react'
import CustomModal from '../../../views/components/Modal/CustomModal'
import WarningIcon from 'static/images/Warning.png'
import ContentHeader from '../../containers/ContentHeader/ContentHeaderNew'
import {
  SETTINGS_REDESIGN_HEADER_HEIGHT,
  BOTTOM_PADDING,
  getEmailFrequencyOptions,
  getEmailFrequencyOptionDisplayText,
  EMAIL_FREQUENCY_TYPES,
} from '../../constants'
import EcgLoader from '../../containers/EcgLoader'
import styles from './TeamMemberFile.css'
import { getName } from '../../containers/Utilities'
import { EditMemberForm } from '../../containers/Forms'
import { needToBustCache } from '../../store/appReducer'
import { checkReferralsOnlyFeatureEnabled, checkTKFeatureEnabled, checkCRPFeatureEnabled, checkRpmFeatureEnabled } from 'configs'
import Toast from '../../../views/components/Modal/SnackBar';
import history from '../../containers/History'
import { getYearMonthDateFormat, addDays } from 'common/dateUtils'
import { FormattedMessage } from 'react-intl'

class TeamMemberFile extends React.Component {
  state = {
    innerHeight: 0,
    innerWidth: 0,
    isReactivateModalOpen:false,
  }

  UNSAFE_componentWillMount() {
    const {
      match,
      dataLastUpdated,
      setInitialTeamMemberData,
      getTeamMemberFileData,
      getAppointmentNotificationsSettings,
    } = this.props
    setInitialTeamMemberData(match)
    getTeamMemberFileData(needToBustCache(dataLastUpdated))
    getAppointmentNotificationsSettings()

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }
 handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    // dispatch(showToastHandler(false));
  }
  handleModalOpen=()=>{
    this.setState({isReactivateModalOpen:true})
  }
  handleConfirmReactivate=()=>{
    this.props.handleOnReactivateAccountClick({isDeactivated: false})
    this.setState({isReactivateModalOpen:false})
  }
  handleModalClose=()=>{
    this.setState({isReactivateModalOpen:false})
  }


  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      getTeamMemberFileData,
      handleOnEditTeamMemberSubmit,
      handleOnTeamMemberDeleteClick,

      selectedTeamMemberId,
      physicians,
      editMemberFormData,
      me,
      notification,
      handleAppointmentNotificationsChange,
      setAccountActivate,
      setAccountDeactivate,
      isAccountDeactivate,
      handleOnReactivateAccountClick,
      handleOnDeactivateAccountClick,
    } = this.props

    const {
      innerHeight,
      innerWidth,
    } = this.state

    const height = innerHeight - SETTINGS_REDESIGN_HEADER_HEIGHT - BOTTOM_PADDING 
    const width = 1180 - (20 * 2)

    const cleanValues = value => {
      const newReminders = {
        emailFrequency: {
          label: getEmailFrequencyOptionDisplayText(value.reminders.emailFrequency),
          id: value.reminders.emailFrequency,
        },
        personalReminder: value.reminders.personalReminder,
        triageReminder: value.reminders.triageReminder,
        personalEsignReportReminder: value.reminders.personalEsignReportReminder,
        teamEsignReportReminder: value.reminders.teamEsignReportReminder,
        teamExportReportReminder: value.reminders.teamExportReportReminder,
      }

      const newProfile = {
        ...value,
        reminders: newReminders,
      }
      return newProfile
    }

    let physician
    let initialValues
    let details
    if (physicians.data && physicians.data.byId[selectedTeamMemberId] && physicians.data.byId[selectedTeamMemberId].reminders && !dataIsFetching) {
      physician = physicians.data.byId[selectedTeamMemberId]
      initialValues = cleanValues(physician)
      details={
        firstname:initialValues.firstName,
        lastName:initialValues.lastName,
        is_deactivated:initialValues.is_deactivated,
        deactivated_at:initialValues.deactivated_at ? getYearMonthDateFormat(addDays(initialValues.deactivated_at), me):'',
      }
      
    }

    const myId = me.data && me.data.profile.id

    const tkEnabled = checkTKFeatureEnabled(me)
    const crpEnabled = checkCRPFeatureEnabled(me)
    const rpmEnabled = checkRpmFeatureEnabled(me)
    const referralsOnlyFeatureEnabled = checkReferralsOnlyFeatureEnabled(me)
   
    return (
      <React.Fragment>
      <div data-page="team-member-file" className={styles.teamMemberFile}>
        <ContentHeader
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={() => getTeamMemberFileData(true)}
          text={physician && getName(physician.firstName, physician.lastName, '')}
          enableBackButton={true}
          showAddPatient={false}
          me={me}
          backButtonIconShow={false}
          backButtonText={<FormattedMessage id="label.back" />}
        />
        {(details&&details.is_deactivated) && (!this.state.isReactivateModalOpen) && (
            <div style={{ height: "72px",
            position: "relative",
            marginTop:'-2rem'
            }}>
              <Toast
                open={true}
                closeHandler={() => this.handleClose()}
                message1={<FormattedMessage id="information.member_account_deactivated_line1" />}
                message2={<FormattedMessage id="information.member_account_deactivated_line2" values={{
                  deactivatedAt: details&&details.deactivated_at
                }}/>}
                severity="error"
                button={false}
                setAccountActivate={setAccountActivate}
                handleOnReactivateAccountClick={handleOnReactivateAccountClick}
                selectedTeamMemberId={selectedTeamMemberId}
                handleModalOpen={this.handleModalOpen}
                
              />
            </div>
          )}
         { (details&&details.is_deactivated) && (!this.state.isReactivateModalOpen) && (
            <div style={{ height: "72px",
            position: "relative",
            marginTop: "2rem",
            marginBottom:'2rem'}}>
              <Toast
                open={true}
                closeHandler={() => this.handleClose()}
                alertMessage={<FormattedMessage id="alert.search_results_not_available" />}
                message1={<FormattedMessage id="information.search_results_not_available_line1" />}
                message2={<FormattedMessage id="information.search_results_not_available_line2" />}
                severity="success"
                button={true}
                setAccountActivate={setAccountActivate}
                handleOnReactivateAccountClick={handleOnReactivateAccountClick}
                selectedTeamMemberId={selectedTeamMemberId}
                handleModalOpen={this.handleModalOpen}
              />
            </div>
          )}

        <div
          className={styles.formWrapper}
          style={{
            height,
          }}
        >
          {!dataIsFetching
            ? ( <div className={styles.formTop}>
                <EditMemberForm
                  me={me}
                  onSubmit={handleOnEditTeamMemberSubmit}
                  initialValues={initialValues}
                  isSubmitting={dataIsFetching}
                  handleOnTeamMemberDeleteClick={handleOnTeamMemberDeleteClick}
                  editMemberFormData={editMemberFormData}
                  isMe={myId === selectedTeamMemberId}
                  showEmailReminder={!referralsOnlyFeatureEnabled}
                  showTKFeatureEnabled={tkEnabled}
                  showCRPFeatureEnabled={crpEnabled}
                  showRPMFeatureEnabled={rpmEnabled}
                  isAdminEnabled = {me && me.data && me.data.profile.permissions.isAdmin}
                  notification={notification}
                  handleAppointmentNotificationsChange={handleAppointmentNotificationsChange}
                  setAccountActivate={setAccountActivate}
                  setAccountDeactivate={setAccountDeactivate}
                  isAccountDeactivate={isAccountDeactivate}
                handleOnReactivateAccountClick={handleOnReactivateAccountClick}
                selectedTeamMemberId={selectedTeamMemberId}
                handleOnDeactivateAccountClick={handleOnDeactivateAccountClick}
                
                />
              </div>
            )
            : (
              <EcgLoader />
            )
          }
        </div>
      </div>
      <CustomModal
          modalType="confirm"
          open={this.state.isReactivateModalOpen}
          closeModalHandler={() => { this.handleModalClose() }}
          icon={WarningIcon}
          iconAltText="Warning Icon"
          heading={<FormattedMessage id="confirmation.reactivate_member" values={{
            firstName: details && details.firstname,
            lastName: details && details.lastName
          }}/>}
          descriptionLine1={<FormattedMessage id="description.reactivate_member" />}
          descriptionLine2=""
          confirmHandler={e => this.handleConfirmReactivate()}
          confirmButtonText={<FormattedMessage id="button.Yes_reactivate" />}
          declineButtonText={<FormattedMessage id="button.cancel" />}
        />
      </React.Fragment>
    )
  }
}

export default TeamMemberFile



// WEBPACK FOOTER //
// ./src/legacy/pages/TeamMemberFile/TeamMemberFile.jsx